import AdvertisersDashboard from "./AdvertisersDashboard";

export default AdvertisersDashboard;
